import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import useBusinessEntityData from '../../hooks/useBusinessEntityData';
import { useAppContext } from '../../lib/contextProviders/contexts/appContext';

const VerifyBusinessAccount = ({ children, redirectTo, byPassVerificationSiteTypes = [] }) => {
  const [isVerified, setIsVerified] = useState(false);
  const { isB2BSite, isEntityDataReady, isUserAccHasBusinessEntity } = useBusinessEntityData();
  const router = useRouter();
  const {
    appState: { siteType },
  } = useAppContext();

  useEffect(() => {
    if (byPassVerificationSiteTypes.includes(siteType)) {
      setIsVerified(true);
    } else if (!isB2BSite) {
      router.push(redirectTo || '/');
    } else if (isEntityDataReady) {
      if (isUserAccHasBusinessEntity) {
        setIsVerified(true);
      } else {
        router.push(redirectTo || '/');
      }
    }
  }, [
    isUserAccHasBusinessEntity,
    isEntityDataReady,
    isB2BSite,
    router,
    redirectTo,
    byPassVerificationSiteTypes,
    siteType,
  ]);

  if (!isVerified) {
    return null;
  }

  return <>{children}</>;
};

export default VerifyBusinessAccount;
